const Users = {
  "Priyankaa2503": {
    name: "Priyanka Ramachandran",
    branch: "IT",
    description:
      "Exploring web and expanding my knowledge by learning innovative concepts, skills and technologies.",
    links: {
      github: "https://github.com/Priyankaa2503",
      instagram: "https://instagram.com/priyankaa__25",
      linkedin: "https://www.linkedin.com/in/priyanka2503/",
      portfolio: "",
    },
  },
  "MurtazaShikari": {
    name: "Murtaza Shikari",
    branch: "IT",
    description:
      "Expanding my knowledge in web development and trying to implement new things by exploring other fields",
    links: {
      github: "https://github.com/MurtazaShikari",
      instagram: "https://instagram.com/shikarimurtaza",
      linkedin: "https://www.linkedin.com/in/murtaza-shikari-606450230",
      portfolio: "",
    },
  },
  "mahek15": {
    name: "Mahek Jain",
    branch: "IT",
    description:
      "Enhancing my skills by learning new things each day and exploring various domains .",
    links: {
      github: "https://github.com/mahek15",
      instagram: "https://instagram.com/mahekj_15",
      linkedin: "https://www.linkedin.com/in/mahek-jain-123aa022a",
      portfolio: "",
    },
  },
  "technophile-04": {
    name: "Shiv Bhonde",
    branch: "IT",
    description:
      "👋 Hey! I'm an avid Full-stack Web2/Web3 Developer. I like to build 🏗 random stuff in my free time. Always learning new things. Ask me about web 🕸 and blockchain ⛓. Feel free to reach out for colab or help 🙌",
    links: {
      github: "https://github.com/technophile-04",
      instagram: "https://instagram.com/shivbhonde.eth",
      linkedin: "https://www.linkedin.com/in/shiv-bhonde-b23a1a205/",
      portfolio: "https://github.com/technophile-04",
    },
  },
  "jinish08": {
    name: "Jinish Shah",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/jinish08",
      instagram: "https://instagram.com/shahjinish08",
      linkedin: "https://www.linkedin.com/in/jinish-shah-70970b206",
      portfolio: "",
    },
  },
  "ayushshah31": {
    name: "Ayush Shah",
    branch: "IT",
    description: "Do what to do, Scooby Doo",
    links: {
      github: "https://github.com/ayushshah31",
      instagram: "https://instagram.com/ayushshah39",
      linkedin: "https://www.linkedin.com/in/ayush-shah-711476225/",
      portfolio: "shahayush177.netlify.app",
    },
  },
  "sauravshah9": {
    name: "Saurav Shah",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/sauravshah9",
      instagram: "https://instagram.com/shahh_saurav",
      linkedin: "https://www.linkedin.com/in/saurav-shah-b4932b165",
      portfolio: "",
    },
  },
  "Vinit45Shah": {
    name: "Vinit Shah",
    branch: "IT",
    description: "I speak fluent sarcasm",
    links: {
      github: "https://github.com/Vinit45Shah",
      instagram: "https://www.instagram.com/vinit.shah45/?hl=en",
      linkedin: "https://www.linkedin.com/in/vinit-shah-699826224",
      portfolio: "",
    },
  },
  "Drishti9421": {
    name: "Drishti Dhingani",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Drishti9421",
      instagram: "https://www.instagram.com/drishti___d/",
      linkedin: "https://www.linkedin.com/in/drishti-dhingani-6381071b8/",
      portfolio: "",
    },
  },
  "Bhavna214": {
    name: "Bhavna Mulchandani",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Bhavna214",
      instagram: "https://www.instagram.com/m.bhavna_/",
      linkedin: "https://www.linkedin.com/in/bhavna-m-b9a90b200",
      portfolio: "",
    },
  },
  "priyankshah3011": {
    name: "Priyank Shah",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/priyankshah3011",
      instagram: "https://instagram.com/priyank_shah._?igshid=YmMyMTA2M2Y=",
      linkedin: "https://www.linkedin.com/in/priyank-shah-2b38601b6",
      portfolio: "",
    },
  },
  "HetviSolanki49701": {
    name: "Hetvi Solanki",
    branch: "IT",
    description: "Hip, hip, array!",
    links: {
      github: "https://github.com/HetviSolanki49701",
      instagram: "https://www.instagram.com/hetvi_solanki01/?hl=en",
      linkedin: "https://www.linkedin.com/in/hetvi-solanki-1b8998223/",
      portfolio: "",
    },
  },
  "ParikhVairag": {
    name: "Vairag Parikh",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/TechyVp",
      instagram: "https://www.instagram.com/parikhvairag/?hl=en",
      linkedin: "https://www.linkedin.com/in/vairag-parikh",
      portfolio: "",
    },
  },
  "neocollege": {
    name: "Prathamesh Nayak",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/neocollege",
      instagram: "https://www.instagram.com/pr.x.th",
      linkedin: "https://www.linkedin.com/in/prathamesh-nayak-5a4a411ba",
      portfolio: "",
    },
  },
  "MadAra-UcHiHa89": {
    name: "Aadil Saudagar",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/MadAra-UcHiHa89",
      instagram: "https://www.instagram.com/im_aadil_/?hl=en",
      linkedin: "https://www.linkedin.com/in/aadil-saudagar-7b467b1b1/",
      portfolio: "",
    },
  },
  "MickyCR7": {
    name: "Meet Vora",
    branch: "IT",
    description: "Any one can do my job, but no one can be me!",
    links: {
      github: "https://github.com/MickyCR7",
      instagram: "https://instagram.com/meeettt___?igshid=YmMyMTA2M2Y=",
      linkedin: "https://www.linkedin.com/in/mnvora",
      portfolio: "",
    },
  },
  "Premdoshi": {
    name: "Prem doshi",
    branch: "IT",
    description: "My name says it all",
    links: {
      github: "https://github.com/Premdoshi1208",
      instagram: "https://instagram.com/premmmmmmm12?igshid=YmMyMTA2M2Y=",
      linkedin: "https://www.linkedin.com/in/prem-doshi-482347224",
      portfolio: "",
    },
  },

  "Nadpi-Pinad": {
    name: "Prasanna Nadkarni",
    branch: "EXTC",
    description: "Agnostic by Choice, Litterateur by Passion, Xenophile with an Adjectival Name!!!",
    links: {
      github: "https://github.com/Nadpi-Pinad",
      instagram: "https://www.instagram.com/agnostic_litterateur756/?hl=en",
      linkedin: "https://www.linkedin.com/in/prasanna-nadkarni-315a96255/",
      portfolio: "",
    },
  },
  "BHAVYAPODDAR": {
    name: "Bhavya Poddar",
    branch: "IT",
    description: "enthusiastic | learning ;) ",
    links: {
      github: "https://github.com/BHAVYAPODDAR",
      instagram: "",
      linkedin: "https://www.linkedin.com/in/bhavya-poddar-b90721250",
    },
  },
  "GajJoshi": {
    name: "Gaj Joshi",
    branch: "CS",
    description: "enthusiastic | learning ;) ",
    links: {
      github: "https://github.com/gajjoshi",
      instagram: "",
      linkedin: "https://www.linkedin.com/in/gaj-joshi-877ba6228",
      portfolio: "",
    },
  },
  "khushishah2443": {
    name: "Khushi Shah",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/khushishah2443",
      instagram: "https://www.instagram.com/kkhushi_shah/?hl=en",
      linkedin: "https://www.linkedin.com/in/khushi-shah-600744235/",
      portfolio: "",
    },
  },
  "RACHIT101": {
    name: "Rachit Gala",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/RacHiT101",
      instagram: "https://www.instagram.com/galaraachit/?hl=en",
      linkedin: "https://www.linkedin.com/in/rachit-gala-ab968b235/",
    },
  },
  "kriti.derasadi": {
    name: "Kriti Derasadi",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Kderasadi",
      instagram: "",
      linkedin: "https://www.linkedin.com/in/kriti-derasadi-1086b522a/",
      portfolio: "",
    },
  },
  "RiddheshMistry": {
    name: "Riddhesh Mistry",
    branch: "EXTC",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Riddhesh0109",
      instagram: "https://www.instagram.com/riddheshh_/?hl=e",
      linkedin: "https://www.linkedin.com/in/riddhesh-mistry-651856235/",
      portfolio: "",
    },
  },
  "ManasPatil0967": {
    name: "RManas Patil",
    branch: "IoT",
    description: "Make good of your tine.",
    links: {
      github: "https://github.com/ManasPatil0967",
      instagram: "",
      linkedin: "https://www.linkedin.com/in/manas-patil-239879224/",
    },
  },
  "Mustansir-M": {
    name: "Mustansir Motiwala",
    description: "Exploring | Learning | Enjoying",
    links: {
      github: "https://github.com/Mustansir-M",
      instagram: "https://www.instagram.com/mustansir_m00/",
      linkedin: "https://www.linkedin.com/in/mustansir-motiwala-65948022a/",
      portfolio: "",
    },
  },
  "SwayamMestry": {
    name: "Swayam Mestry",
    branch: "IoT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/SwayamMestry",
      instagram: "https://www.instagram.com/5wayam/",
      linkedin: "",
      portfolio: "",
    },
  },
  "AryanGupta2406": {
    name: "Aryan gupta",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/AryanGupta2406",
      linkedin: "https://www.linkedin.com/in/aryan-gupta-0a348522a/",
      portfolio: "",
    },
  },
  "anujbohra23": {
    name: "Anuj Bohra",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/anujbohra23",
      instagram: "https://instagram.com/bohraanuj23?igshid=YmMyMTA2M2Y=",
      linkedin: "https://www.linkedin.com/in/anuj-bohra-977a75251",
      portfolio: "",
    },
  },
  "tanayajoshi": {
    name: "Tanaya Joshi",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/tanayajoshi",
      instagram: "https://www.instagram.com/invites/contact/?i=16yqg1wzr2n32&utm_content=2h7oe8s",
      linkedin: "http://linkedin.com/in/tanaya-joshi-4b95b7230",
    },
  },
  "neminsheth": {
    name: "Nemin Sheth",
    branch: "IT",
    description: "Aspiring Engineer",
    links: {
      github: "https://github.com/neminsheth",
      instagram: "https://www.instagram.com/nemin_sheth/",
      linkedin: "https://www.linkedin.com/in/nemin-sheth-dj-it/",
      portfolio: "",
    },
  },
  "shivani2442": {
    name: "ShivaniPatel",
    branch: "IT",
    description: "Exploring | Learning | Enjoying",
    links: {
      github: "https://github.com/shivani2442",
      instagram: "https://www.instagram.com/shivani_.24/",
      linkedin: "https://www.linkedin.com/in/shivani-patel-090671235/",
      portfolio: "",
    },
  },
  "tabss007": {
    name: "Tanvi Bhide",
    description: "Go with the flow",
    links: {
      github: "https://github.com/tabss007",
      linkedin: "https://www.linkedin.com/in/temp10/",
      instagram: "",
      portfolio: "",
    },
  },
  "niharn22": {
    name: "Nihar Nandoskar",
    branch: "IT",
    description: "Go with the flow",
    links: {
      github: "https://github.com/Nadpi-Pinad",
      instagram: "https://www.instagram.com/agnostic_litterateur756/?hl=en",
      linkedin: "https://www.linkedin.com/in/prasanna-nadkarni-315a96255/",
      portfolio: "",
    },
  },
  "MorakhiaDhimant": {
    name: "Dhimant Morakhia",
    branch: "IT",
    description: "Exploring new fields to expand my knowledge.",
    links: {
      github: "https://github.com/MorakhiaDhimant",
      instagram: "https://www.instagram.com/temp10/?hl=en",
      linkedin: "https://www.linkedin.com/in/dhimant-morakhia-7b49a2237/",
      portfolio: "",
    },
  },
  "vaishkadukar": {
    name: "Vaishnavi Kadukar",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/vaishkadukar",
      instagram: "https://www.instagram.com/vaishnavi_kadukar",
      linkedin: "https://www.linkedin.com/in/vaishnavi-kadukar-883975250/",
    },
  },
  "dbs-2012": {
    name: "Darsh Shah",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/dbs-2012",
      instagram: "https://www.instagram.com/darshshah2002/",
      linkedin: "https://www.linkedin.com/in/darsh-shah-7b9686226/",
      portfolio: "",
    },
  },
  "TanmayRaina": {
    name: "Tanmay Raina",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Tanmay Raina",
      instagram: "https://www.instagram.com/tanmay_raina/?hl=en",
      linkedin: "https://www.linkedin.com/in/temp10/",

      portfolio: "",
    },
  },
  "KelyMistry": {
    name: "Kely Mistry",
    branch: "IT",
    description: "Go with the flow",
    links: {
      github: "https://github.com/KelyMistry",
      instagram: "",
      linkedin: "",
      portfolio: "",
    },
  },
  "Bhargavi1210": {
    name: "Bhargavi Vaidya",
    branch: "AI and DS",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Bhargavi1210",
      instagram: "",
      linkedin: "",
      portfolio: "",
    },
  },
  "Viral0401": {
    name: "Viral Dalal",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Viral0401",
      instagram: "https://www.instagram.com/wtfviral_/?hl=en",
      linkedin: "https://www.linkedin.com/in/viral-dalal-424827251",
    },
  },
  "rockeyur": {
    name: "Keyur Parmar",
    branch: "IT",
    description:
      "Exploring web and expanding my knowledge by learning innovative concepts, skills and technologies.",
    links: {
      github: "https://github.com/rockeyur",
      instagram: "https://instagram.com/keyur_parmar_1203",
      linkedin: "https://www.linkedin.com/in/keyur-parmar-5414a8238/",
    },
  },
  "Aditya-Dalvi": {
    name: "Aditya Dalvi",
    branch: "IOT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Aditya-Dalvi",
      instagram: "https://www.instagram.com/aditya_dalvi_07/",
      linkedin: "https://bit.ly/3CfK8CR",
      portfolio: "",
    },
  },
  "IshaPatade": {
    name: "Isha Patade",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/IshaPatade",
      instagram: "https://www.instagram.com/_ishaaaa__",
      linkedin: "https://www.linkedin.com/in/isha-patade-096226252/",
      portfolio: "",
    },
  },
  "AnuragLade": {
    name: "Anurag Lade",
    branch: "IT",
    description:
      "Expanding my knowledge in web development and trying to implement new things by exploring other fields",
    links: {
      github: "GitHub-www.github.com/Anurag11L",
      instagram: "https://www.instagram.com/_anureg_/",
      linkedin: "LinkIn-linkedin.com/in/anurag-lade-aaa4b022a",
      portfolio: "",
    },
  },
  "kushlav238": {
    name: "Kushal Vadodaria",
    branch: "IT",
    description: "Carpe Deim",
    links: {
      github: "https://github.com/kushalv238",
      instagram: "https://www.instagram.com/kushalv238",
      linkedin: "https://www.linkedin.com/in/kushal-vadodaria/",
      portfolio: "",
    },
  },
  "Bhavyaz": {
    name: "Bhavya Zaveri",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/bhavyaz",
      instagram: "https://www.instagram.com/bhavya_zaveri",
      linkedin: "https://www.linkedin.com/in/bhavya-zaveri-300b11151/",
      portfolio: "",
    },
  },
  "Vedant4K": {
    name: "Vedant Chavan",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Vedant4K",
      instagram: "https://www.instagram.com/vedantchavan25/",
      linkedin: "https://www.linkedin.com/in/vedant-chavan-772b35229",
      portfolio: "",
    },
  },
  "MithilBavishi": {
    name: "Mithil Bavishi",
    branch: "IT",
    description: "Each program has, at minimum, one unnecessary line of code.",
    links: {
      github: "https://github.com/MightyM17",
      instagram: "https://instagram.com/mithilbavishi",
      linkedin: "https://www.linkedin.com/in/mithil-bavishi/",
    },
  },
  "Rushii": {
    name: "Rushikesh Gadewar",
    branch: "IT OP",
    description: "Don't Tell Anyone I Am A Ninja!",
    links: {
      github: "",
      instagram: "https://www.instagram.com/rushikeshgadewar197/",
      linkedin: "https://www.linkedin.com/in/rushikesh-gadewar-4a6847210/?originalSubdomain=in",
      portfolio: "",
    },
  },
  "jeniels": {
    name: "Jeniel Shah",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/jeniels/",
      instagram: "",
      linkedin: "https://www.linkedin.com/in/jeniel-shah-77a455205/",
      portfolio: "",
    },
  },
  "shahsamkit3124": {
    name: "Samkit Shah",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/shahsamkit3124",
      instagram: "https://www.instagram.com/_samkit.shah_3124/",
      linkedin: "https://www.linkedin.com/in/samkit-shah-752802216/",
      portfolio: "",
    },
  },
  "udayIT03": {
    name: "Uday Baldha",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/udayIT03",
      instagram: "",
      linkedin: "https://www.linkedin.com/in/uday-b-95b73322b",
      portfolio: "",
    },
  },
  "ParvKaria": {
    name: "Parv Karia",
    branch: "CSE [IOT]",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/ParvKaria",
      instagram: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
      linkedin: "https://www.linkedin.com/in/parv-karia-b2748222a/",
      portfolio: "",
    },
  },
  "DhruvJ014": {
    name: "Dhruv Jain",
    branch: "CSE-DS",
    description: "Learning Github rn :)",
    links: {
      github: "https://github.com/dhruvj014",
      instagram: "https://instagram.com/dhruvjain_014",
      linkedin: "https://www.linkedin.com/in/dhruvjain314/",
      portfolio: "",
    },
  },
  "Vsoham": {
    name: "Soham rane",
    branch: "IOT",
    description:
      "Exploring web and expanding my knowledge by learning innovative concepts, skills and technologies.",
    links: {
      github: "",
      instagram: "",
      linkedin: "",
      portfolio: "",
    },
  },
  "Sohamthatte": {
    name: "Soham Thatte",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Sohamthatte",
      instagram: "https://www.instagram.com/soham.thatte/",
      linkedin: "https://www.linkedin.com/in/soham-thatte-11b4b3250/",
      portfolio: "Gitforgeeks",
    },
  },
  "AdityaT27": {
    name: "Aditya Thatte",
    branch: "IT",
    description: "Optimizing",
    links: {
      github: "https://github.com/Thatte-Aditya/Git-For-Geeks2",
      instagram: "https://www.instagram.com/thatte_aditya/",
      linkedin: "https://www.linkedin.com/in/aditya-thatte-b90675235/",
      portfolio: "",
    },
  },
  "Hydrosmasher": {
    name: "Hrishikesh Karmalkar",
    branch: "AI & DS",
    description: "",
    links: {
      github: "",
      instagram: "",
      linkedin: "",
      portfolio: "",
    },
  },
  "rahul15rc": {
    name: "Rahul Chougule",
    branch: "IT",
    description: "-_-",
    links: {
      github: "https://github.com/rahul15rc",
      instagram: "https://www.instagram.com/rahulll._.15/",
      linkedin: "https://www.linkedin.com/in/rahulchougule15/",
      portfolio: "",
    },
  },
  "quintessentialdevrev": {
    name: "Satvam Thakkar",
    branch: "DS",
    description: "The only thing that I know, is that I know nothing",
    links: {
      github: "https://github.com/quintessentialdevrev",
      instagram: "https://www.instagram.com/satvam_thakkar/",
      linkedin: "https://www.linkedin.com/in/satvam-thakkar-5a5744250/",
      portfolio: "",
    },
  },
  "sarthakmahale123": {
    name: "Sarthak Mahale",
    branch: "IT",
    description: "Insert Chhapri bio here:",
    links: {
      github: "https://github.com/sarthakmahale123",
      instagram: "https://instagram.com/sarthak_mahale12",
      linkedin: "https://www.linkedin.com/in/",
      portfolio: "",
    },
  },
  "PARZIVAL0609": {
    name: "Dhruv Shah",
    branch: "IT",
    description: "",
    links: {
      github: "https://github.com/PARZIVAL0609",
      instagram: "https://instagram.com/parzival_069",
      linkedin: "https://www.linkedin.com/in/dhruv-shah-21a151250/",
      portfolio: "",
    },
  },
  "Udayanvats": {
    name: "Udayan vats",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Udayanvats",
      instagram: "https://www.instagram.com/udayan.vats/",
      linkedin: "https://www.linkedin.com/in/udayan-vats-302a1b225/",
      portfolio: "",
    },
  },
  "hetnakhua": {
    name: "Het Nakhua",
    branch: "IT",
    description:
      "Exploring web and expanding my knowledge by learning innovative concepts, skills and technologies.",
    links: {
      github: "https://github.com/hetnakhua",
      instagram: "https://instagram.com/hetnakhua",
      linkedin: "https://www.linkedin.com/in/het-nakhua/",
      portfolio: "",
    },
  },
  "jay-096": {
    name: "Jay Mehta",
    branch: "COMPS",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/jay-096",
      instagram: "https://www.instagram.com/jayy_mehta09/",
      linkedin: "https://www.linkedin.com/in/jay-mehta-b1a36b214/",
      portfolio: "hi",
    },
  },
  "rakite28": {
    name: "Rachit Bhojani",
    branch: "COMPS",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/rakite28/",
      instagram: "https://www.instagram.com/rakite28/",
      linkedin: "https://www.linkedin.com/in/rachit-bhojani-b1a36b214",
      portfolio:
        "Love to code, design and develop interesting and world changing(hopefully) applications Contributing to Open-Source to learn from the community.",
    },
  },
  "yashshahbhai": {
    name: "YASH SHAH",
    branch: "IT",
    description:
      "Expanding my knowledge in web development and trying to implement new things by exploring other fields",
    links: {
      github: "https://github.com/yashshahbhai",
      instagram: "",
      linkedin: "",
      portfolio: "",
    },
  },
  "Anusshkaha": {
    name: "Anusshka Choudhary",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Anusshkaha",
      instagram: "https://instagram.com/anusshka_chaudhary?igshid=1cnbzwatgvtlg",
      linkedin: "https://www.linkedin.com/in/anusshka-chaudhary-129751221/",
      portfolio: "",
    },
  },

  "ssharma2003": {
    name: "Shreya Sharma",
    branch: "IT",
    description: "Exploring | Learning | Enjoying",
    links: {
      github: "https://github.com/ssharma2003",
      instagram: "https://www.instagram.com/im_aadil_/?hl=en",
      linkedin: "https://www.linkedin.com/in/aadil-saudagar-7b467b1b1/",
    },
  },
  "SKyde": {
    name: "Vansh Jain",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/MadAra-UcHiHa8https://github.com/vanshJ314",
      instagram: "https://www.instagram.com/vanshj03/?hl=en",
      linkedin: "hhttps://www.linkedin.com/in/vansh-jain-400696235/",
      portfolio: "",
    },
  },
  "priyal3251": {
    name: "Priyal Donda",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/priyal3251",
      instagram: "https://www.instagram.com/priyalll_d/?hl=en",
      linkedin:
        "https://www.linkedin.com/in/priyal-donda-55648522a/edit/forms/contact-info/new/?profileFormEntryPoint=PROFILE_TOP_CARD_EDIT_FORM",
      portfolio: "",
    },
  },
  "wafflesblossom0703": {
    name: "kanika Chitnis",
    branch: "IOT",
    description:
      "Exploring web and expanding my knowledge by learning innovative concepts, skills and technologies.",
    links: {
      github: "https://github.com/wafflesblossom0703",
      instagram: "https://www.instagram.com/_kanikaa_18?r=nametag",
      linkedin: "",
      portfolio: "",
    },
  },
  "Ronakk4": {
    name: "Ronakk Javeri",
    branch: "IT",
    description: "Exploring | Learning",
    links: {
      github: "https://github.com/Ronakk4",
      instagram: "https://www.instagram.com/Ronakk,javeri",
      linkedin: "",
      portfolio: "",
    },
  },
  "leander006": {
    name: "Leander D'silva",
    branch: "IT",
    description: "Exploring blockchain and expanding my knowledge by learning innovative concepts",
    links: {
      github: "https://github.com/leander006",
      instagram: "https://www.instagram.com/leander_dsilva06",
      linkedin: "https://www.linkedin.com/in/leander06",
      portfolio: "https://leanderdsilva.netlify.app",
    },
  },
  "pratikwadke02": {
    name: "Pratik Wadke",
    branch: "IT",
    description: "Full Stack Developer and VCP Infotech Web at ACM",
    links: {
      github: "https://github.com/pratikwadke02",
      instagram: "https://instagram.com/_praxxk_",
      linkedin: "https://www.linkedin.com/in/pratik-wadke-904b5821b/",
      portfolio: "",
    },
  },
  "nihal5617": {
    name: "Nihal Gupta",
    branch: "IT",
    description: "Full Stack Developer and App Developer",
    links: {
      github: "https://github.com/nihal5617",
      instagram: "https://www.instagram.com/nihal_5617",
      linkedin: "https://www.linkedin.com/in/nihal-gupta-424943208/",
      portfolio: "https://profile.nihal.works/",
    },
  },
};

export default Users;
